import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import {
  handleSelectAll,
  handleSelect,
  loadExaminationUserFilter,
} from '../AddExaminerDrawer/event'
import { setInitialAddExaminerDrawer } from 'src/redux/slices/eExamination'
import SearchBox from '../AddExaminerDrawer/SearchBox'
import _ from 'lodash'
import { StyledCheckbox } from '../AddExaminerDrawer/Styled'
import { StyledTableCell } from './Styled'

const AddExaminerTableMobile = () => {
  const dispatch = useDispatch()
  const user = JSON.parse(localStorage.getItem('user'))
  const {
    examinerList,
    examinerSearchText,
    selectedExaminerList,
    hasMore,
    page,
    isFetch,
    examiners,
  } = useSelector(
    (state) => ({
      examinerList: state.eExamination.examinerList,
      examinerSearchText: state.eExamination.examinerSearchText,
      selectedExaminerList: state.eExamination.selectedExaminerList,
      hasMore: state.eExamination.examinationUserFilter.hasMore,
      page: state.eExamination.examinationUserFilter.page,
      isFetch: state.eExamination.examinationUserFilter.isFetch,
      examiners: state.eExamination.examiners,
    }),
    shallowEqual
  )
  useEffect(() => {
    if (user) {
      dispatch(
        loadExaminationUserFilter({ user, page: 1, search: examinerSearchText })
      )
    }
    return () => {
      dispatch(setInitialAddExaminerDrawer())
    }
  }, [])
  return (
    <TableContainer
      onScroll={(e) => {
        if (!hasMore || isFetch) return
        if (
          e.target.offsetHeight + e.target.scrollTop + 50 >
          e.target.scrollHeight
        ) {
          dispatch(
            loadExaminationUserFilter({
              user,
              page: page + 1,
              search: examinerSearchText,
            })
          )
        }
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell colSpan={3} sx={{ borderBottom: 0 }}>
              <SearchBox />
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell sx={{ width: 50, fontWeight: '500' }}>
              <StyledCheckbox
                checked={
                  examinerList.length > 0 &&
                  _.isEqual(
                    _.sortBy(selectedExaminerList, ['uuid']),
                    _.sortBy(examinerList, ['uuid'])
                  )
                }
                onChange={(e) => dispatch(handleSelectAll(e.target.checked))}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ width: 135, fontWeight: '500' }}>
              ชื่อ - นามสกุล
            </StyledTableCell>
            <StyledTableCell sx={{ width: 135, fontWeight: '500' }}>
              เบอร์โทรศัพท์
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {examinerList.map((ele, ind) => {
            if (examiners.some((e) => e.uuid === ele.uuid)) {
              return ''
            } else {
              return (
                <TableRow key={ind}>
                  <StyledTableCell>
                    <StyledCheckbox
                      checked={Boolean(
                        _.find(selectedExaminerList, (selected) => {
                          return selected.uuid == ele.uuid
                        })
                      )}
                      onChange={(e) =>
                        dispatch(
                          handleSelect({ check: e.target.checked, value: ele })
                        )
                      }
                    />
                  </StyledTableCell>
                  <StyledTableCell>{`${ele.firstNameTH} ${ele.lastNameTH}`}</StyledTableCell>
                  <StyledTableCell>{ele.mobileNo || '-'}</StyledTableCell>
                </TableRow>
              )
            }
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AddExaminerTableMobile
